const tracePaths = [
  "checkout.mpp.v1.CheckoutMppV1Service",
  "checkout.fe.v1.CheckoutFrontendV1Service",
];

export const tracePathsFilter = (url: string) =>
  tracePaths.some((tracePath) => url.includes(tracePath));
